import DocumentList from '../../Component/ReusableCode/reUsableDocument'
import { IMAGE_BASE_PATH_DBRAIMT } from '../../Config/Config'
import SyllabusData from '../../Assets/JSON/Academics/Syllabus.json'

const Syllabus = () => {
  return (
    <div>
      <DocumentList
        data={SyllabusData}
        title="Syllabus"
        basePath={IMAGE_BASE_PATH_DBRAIMT}
        navigatePath="/syllabus"
      />
    </div>
  )
}

export default Syllabus
